export default __webpack_public_path__ + "static/logo-c3cfe40ac72d110c2c368a08ec292be0.png";